class AuthenticatorCodeValidator {
    public static readonly codeLength: number = 6;

    public static validate(code: string | null): boolean {
        return (
            code?.length === AuthenticatorCodeValidator.codeLength
            && /^\d+$/.test(code)
        );
    }

    public validate(code: string | null): boolean {
        return AuthenticatorCodeValidator.validate(code);
    }
}

export { AuthenticatorCodeValidator };
